import { getAdId, getUserId } from './cookie';
import { setupFinnGlobalVar } from './finn';
import { initApnListeners, trackContentboard } from './listeners';
import { AppNexusData, Apntag, PageOpts } from '../../shared/types/ast';
import { markSetPageOpts, markTagsLoaded } from './performance';
export { initTakeover, injectTakeoverTemplate, isTakeover } from './takeover';

function setExternalUid(pageOpts: PageOpts) {
    if (pageOpts) {
        const userId = getAdId();
        const extId = getUserId();
        let idSrc = '0';
        pageOpts.user = {};
        pageOpts.user.externalUid = userId;
        if (userId) {
            idSrc = extId ? '2' : '1';
        }
        pageOpts.keywords = pageOpts.keywords || {};
        pageOpts.keywords['no-generic-externalid_src'] = idSrc;
        if (userId === 'DO_NOT_TRACK') {
            pageOpts.user.dnt = true;
        }
        if (navigator && navigator.doNotTrack === '1') {
            pageOpts.user.dnt = true;
        }
    }
    return pageOpts;
}

export function requestBanners(
    apntag: Apntag,
    appNexusData: AppNexusData,
    loadTags = true,
    addListeners = true,
) {
    if (apntag && apntag.anq && appNexusData) {
        apntag.anq.push(() => {
            setupFinnGlobalVar(appNexusData);
            const pageOptsWithUserId = setExternalUid(appNexusData.pageOpts);
            markSetPageOpts();
            apntag.setPageOpts(pageOptsWithUserId);
            if (loadTags) {
                Object.values(appNexusData.tags).forEach(apntag.defineTag);
                markTagsLoaded();
                apntag.loadTags();
            }
            if (addListeners) {
                initApnListeners(apntag, appNexusData);
            }
        });
    }
}

export { initApnListeners, trackContentboard };
